<script lang="ts">
  import { t } from '../i18n/index.svelte';
  import { studio } from '../state.svelte';
  import { DEFAULT_STEREO, maxSeparationPx } from '../types';
  import Section from './ui/Section.svelte';
  import Slider from './ui/Slider.svelte';
  import Toggle from './ui/Toggle.svelte';

  const p = $derived(studio.stereo);
  const sep = $derived(maxSeparationPx(p));
</script>

<Section title={t('stereo.title')}>
  {#snippet aside()}
    <button class="ghost small" onclick={() => (studio.stereo = { ...DEFAULT_STEREO, seed: p.seed })}
      >{t('common.reset')}</button
    >
  {/snippet}
  <div class="seg">
    <button class:on={p.mode === 'wall_eyed'} onclick={() => (p.mode = 'wall_eyed')} data-testid="mode-wall"
      >{t('stereo.wallEyed')}</button
    >
    <button class:on={p.mode === 'cross_eyed'} onclick={() => (p.mode = 'cross_eyed')} data-testid="mode-cross"
      >{t('stereo.crossEyed')}</button
    >
  </div>
  <Slider
    label={t('stereo.patternWidth')}
    bind:value={p.pattern_width}
    min={0}
    max={300}
    format={(v) => (v === 0 ? t('stereo.auto', { px: sep }) : `${v} px`)}
    hint={t('stereo.patternWidthHint')}
  />
  {#if p.pattern_width === 0}
    <div class="grid2">
      <label class="field"
        ><span>{t('stereo.eyeSep')}</span><input
          type="number"
          min="30"
          max="90"
          step="0.5"
          bind:value={p.eye_sep_mm}
        /></label
      >
      <label class="field"
        ><span>{t('stereo.dpi')}</span><input type="number" min="30" max="600" bind:value={p.dpi} /></label
      >
    </div>
  {/if}
  <Slider
    label={t('stereo.mu')}
    bind:value={p.mu}
    min={0.1}
    max={0.6}
    step={0.01}
    format={(v) => v.toFixed(2)}
    hint={t('stereo.muHint')}
  />
  <Slider
    label={t('stereo.oversample')}
    bind:value={p.oversample}
    min={1}
    max={8}
    format={(v) => `×${v}`}
    hint={t('stereo.oversampleHint')}
  />
  <div class="row seedrow">
    <label class="field grow"
      ><span>{t('stereo.seed')}</span><input type="number" min="0" bind:value={p.seed} data-testid="seed" /></label
    >
    <button title={t('stereo.randomSeed')} onclick={() => (p.seed = Math.floor(Math.random() * 1e9))}>🎲</button>
  </div>
  <Toggle label={t('stereo.guideDots')} bind:checked={p.guide_dots} />
</Section>

<style>
  .field {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 13px;
  }
  .grow {
    flex: 1;
  }
  .seedrow {
    align-items: end;
  }
  .small {
    font-size: 12px;
    padding: 2px 8px;
  }
</style>
